export const ArrowButton = ({ 
  text = "Know More",
  textColor = "#ea0085",
  borderColor = "#EA0085",
  width = 322.83,
  height = 82,
  fontSize = 24,
  fontFamily = "Proxima Nova Bold, Arial, sans-serif",
  xpos= "50%",
  ypos = "50%",
  translateX = 0,     // <-- NEW
  translateY = 0  
}) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 322.83 82"
      width={width}
      height={height}
      style={{ display: 'block',transform: `translate(${translateX}px, ${translateY}px)`  }}
    >
      <path
        d="M281.83,1H40.75C20.16,1,3.22,16.55,1,36.55h49.65l-14.41-14.41c-1.74-1.74-1.74-4.56,0-6.3,1.74-1.74,4.56-1.74,6.3,0l21.91,21.91c.9.9,1.32,2.08,1.3,3.26.03,1.17-.4,2.36-1.3,3.26l-21.91,21.91c-1.74,1.74-4.56,1.74-6.3,0-1.74-1.74-1.74-4.56,0-6.3l14.41-14.41H1c2.22,19.99,19.16,35.55,39.75,35.55h241.08c22.09,0,40-17.91,40-40h0c0-22.09-17.91-40-40-40Z"
        stroke={borderColor}
        strokeWidth="2"
        fill="none"
      />
      <text
        x={xpos}
        y={ypos}
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize={`${fontSize}px`}
        fontFamily={fontFamily}
        fill={textColor}
      >
        {text.split(/\n|\\n/).map((line, index, array) => (
          <tspan
            key={index}
            x="50%"
            dy={index === 0 ? `-${(array.length - 1) * 0.5}em` : '1.2em'}
          >
            {line.trim()}
          </tspan>
        ))}
      </text>
    </svg>
  );
};